const { gql } = require("@apollo/client");

const settings = gql`
  {
    key
    value
    parsed_value
  }
`;

const setting = gql`
  {
    value
  }
`;

export { settings , setting };
